module.exports = {"Type":"Carousel","Output":true,"Fields":[{"label":"Show as list","type":"yesno","name":"showAsList","advanced":false,"description":"If true the carousel will be displayed as a list","defaultValue":"No"},{"label":"Show only","type":"yesno","name":"showOnly","advanced":false,"description":"If true the user input is not awaited; otherwise yes","defaultValue":"No"}],"Header":{"Color":"white","BackgroundColor":"#2f83bd","Text":""}}


//////////////////
// WEBPACK FOOTER
// ./src/designer/widgets/Carousel.json
// module id = 687
// module chunks = 0